import { Completed } from "monday-ui-react-core/dist/allIcons";
import { CloseRound } from "monday-ui-react-core/dist/allIcons";
import styled from "styled-components";

import { ExitCode } from "@/types/common";

interface CloneProgressLineProps {
  status: string;
  label: string;
}

const ProgressLineSection = styled.div`
  font-family: var(--font-family);
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  color: $bling-bling;

  span:first-child {
    margin-right: 2px;
  }

  span {
    padding-top: 2px;
  }
`;
export default function CloneProgressLine({ status, label }: CloneProgressLineProps) {
  let icon;
  switch (status) {
    case ExitCode.SUCCESS:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      icon = <Completed size={14} color={"green"} />;
      break;
    default:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      icon = <CloseRound size={12} color={"red"} />;
  }
  return (
    <ProgressLineSection>
      <span style={{ marginRight: "5px" }}>{icon}</span>
      <span>{label}</span>
    </ProgressLineSection>
  );
}
